import React from 'react';

const LandingPage = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #3a4f90 0%, #19647e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        padding: '40px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        {/* Sellflows Logo */}
        <div style={{
          marginBottom: '30px',
          display: 'flex',
          justifyContent: 'center'
        }}>
                     <img 
             src="/sellflows-logo-white.png"
             alt="Sellflows"
             style={{
               width: '200px',
               height: '60px',
               objectFit: 'contain',
               borderRadius: '10px',
               border: '1px solid rgba(255, 255, 255, 0.3)',
               background: 'rgba(255, 255, 255, 0.1)'
             }}
           />
        </div>
        
        <h1 style={{
          fontSize: '2.5rem',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          Voice AI Widget
        </h1>
        
        <p style={{
          fontSize: '1.2rem',
          marginBottom: '30px',
          opacity: '0.9'
        }}>
          Interactive voice AI assistant for your website
        </p>
        
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          marginBottom: '30px'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            padding: '15px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <h3 style={{ marginBottom: '10px', fontSize: '1.1rem' }}>For Agencies</h3>
            <p style={{ marginBottom: '15px', opacity: '0.8' }}>
              Manage client configurations, API keys, and widget settings
            </p>
            <a 
              href="/admin"
              style={{
                display: 'inline-block',
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '8px',
                textDecoration: 'none',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
              }}
            >
              Access Agency Panel
            </a>
          </div>
          
          <div style={{
            background: 'rgba(255, 255, 255, 0.1)',
            padding: '15px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <h3 style={{ marginBottom: '10px', fontSize: '1.1rem' }}>For Clients</h3>
            <p style={{ marginBottom: '15px', opacity: '0.8' }}>
              Access your personalized widget configuration
            </p>
            <a 
              href="/client-login"
              style={{
                display: 'inline-block',
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '8px',
                textDecoration: 'none',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
              }}
            >
              Client Login
            </a>
          </div>
        </div>
        
        <div style={{
          fontSize: '0.9rem',
          opacity: '0.7',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)',
          paddingTop: '20px'
        }}>
          <p>Powered by Sellflows Technology</p>
          <p>© 2025 Sellflows.com — All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 